// import React from 'react'
import LoginBgImage from '../../assets/images/LoginBgImage.png'
import './Login.css';
import React,{useState,useEffect, useRef} from 'react'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

import { msalInstance } from '../../index';
import Home from '../Home/Home';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginDetails } from '../../app/slice/loginSlice';
import axios from 'axios';
import  config  from '../../env.json';
import { getAuthApi } from '../../apis/authApi/authApi';
import { setUserVirtualNumber,setUserDetails } from '../../app/slice/authApiSlice';
import { getClientApi } from '../../apis/userPermissionApi/userPermissionApi';
import { getAllClients } from '../../apis/createEnvApi/createEnvApi';
import { setActiveClient } from '../../app/slice/clientSlice';
import { useNavigate } from 'react-router-dom';
// import { useTranslation, initReactI18next } from "react-i18next";





function Login() {
  // eslint-disable-next-line

  // const { t } = useTranslation();
  // const t=(test)=>{return test};
  const navigate = useNavigate();
  const [IsLoggingSilently, setIsLoggingSilently] = useState(false);
  const [IsLoggedIn, setIsLoggedIn] = useState(false);
  const EmpId=useSelector((state:any)=>state.authApiSlice.Id);
  useEffect(() => {
    if(EmpId){
    getAllClients(EmpId,(res:any)=>{
      if(res)
      dispatch(setActiveClient(res[0]));
    });
  }
  }, [EmpId])

  const dispatch = useDispatch();



    const skipHeader = useSelector((state: any) => state.login.skipHeader);
    const axiosInstance=axios.create();


    axios.interceptors.request.use(async (request: any) => {
      const updatedToken = sessionStorage.getItem("login");

      console.log(updatedToken);
      console.log("request", request);
      console.log("skipHeader", skipHeader);

      if (updatedToken && !skipHeader) {
        if (updatedToken.length > 0) {
          request.headers.Authorization = "Bearer " + updatedToken;
        }
      }

      return request;
    }, error => {
      console.log(error);
      return Promise.reject(error);
    });

  
    axios.interceptors.response.use(response => {
      return response;
    }, async error => {
      console.log(error);
      const originalRequest = error.config;
    
      if (error.response) {
        if (
            error.response.status === 401 &&
            originalRequest.url === config.REACT_APP_AUTH_API_BASE+"/auth/?EndpointType=SMS"
            // true
          ) {
            localStorage.clear();
            navigate("/error");
            return Promise.reject(error);
          }
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
    
          const loginDetails = sessionStorage.getItem("loginName");
          var currentAccount: any = msalInstance.getAccountByUsername(loginDetails as string);
    
          console.log("loginRequest::", loginRequest);
          console.log("currentAccount::", currentAccount);
          console.log("loginDetails::", loginDetails);
          console.log("originalRequest::", originalRequest);
    
          var silentRequest: any = {
            scopes: loginRequest.scopes,
            account: currentAccount,
            forceRefresh: false
          };
    
          var request = {
            scopes: loginRequest.scopes,
            loginHint: currentAccount.username
          };
    
          let tokenResponse;
    
          try {
            tokenResponse = await msalInstance.acquireTokenSilent(silentRequest);
          } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
              // fallback to interaction when silent call fails
              await msalInstance.acquireTokenRedirect(request as any);
            }
          }
    
          console.log("Silent Response");
          console.log(tokenResponse);
    
          if (tokenResponse) {
            console.log("tokenResponse", tokenResponse);
    
            sessionStorage.setItem("login", tokenResponse.accessToken);
            dispatch(setLoginDetails({
              'token': tokenResponse.accessToken,
              'userName': tokenResponse.account?.username,
              'userAccount': tokenResponse
            }));
    
            originalRequest.headers.Authorization = "Bearer " + tokenResponse.accessToken;
            console.log(originalRequest);
            return axiosInstance(originalRequest); // Use axiosInstance instead of axios
          }
        }
      }
    
      return Promise.reject(error);
    });
    
    
    
    const handleLogin = () => {

        msalInstance.loginRedirect(loginRequest).then((e: any)=>{
          console.log(e)
          
        }).catch((e:any) => {
            
          console.log(e);
          
        });
    }




  return (
    <>
    <AuthenticatedTemplate>
          <Home /> 
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <div className="login-layout-bg login-bg">

              <div className="login-left-div">
                <img src={LoginBgImage} alt="LoginImage" />
              </div>

              <div className="login-right-div">
                <h1 className="login-text font--xl">let's sign you in</h1>
                <h4 className="login-text font--lg">
                  Your organization uses the following login modes to access the
                  application
                </h4>

                <button
                  className="rounded-primary-40 btn font--btn"
                  type="button"
                  onClick={handleLogin}
                >
                  Login with {config.REACT_APP_AUTH_TYPE}
                </button>


              </div>
            </div>
        </UnauthenticatedTemplate>
  </>
  )
}



export default Login